const cb = {
    callback: function(positions) {
        // callback every position change
        console.log(positions);
    }
};
const rellax = new Rellax('.js-parallax');
